export const BENTO = 'BENTO' as const;
export const TRANSITION = 'TRANSITION' as const;
export const SYNC = 'SYNC' as const;
export const OTHER = 'OTHER' as const;

export type IssueUpdateOrigin = typeof BENTO | typeof TRANSITION | typeof SYNC | typeof OTHER;
